import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DrawerLayout from '../../components/shared/DrawerLayout';
import BookingDrawerBody from './BookingDrawerBody';
import AreaEditDrawer from '../../components/AreaEditDrawer';
import { ViewMode } from '../../hooks/viewMode';
import { selectSelectedBooking } from '../../redux/store/userData/trips';
import {
  selectViewMode,
  closeBookingDrawerAndSetQueries,
} from '../../redux/store/ui/common';
import { ViewType } from '../../hooks/useViewType';
import { selectViewType } from '../../redux/store/ui/common/selectors';
import PricingEditDrawer from '../PricingEditDrawer';
import NestedDrawer from '../shared/NestedDrawer';

const BookingDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);
  const selectedBooking = useSelector(selectSelectedBooking);

  const handleOnClose = () => {
    dispatch(closeBookingDrawerAndSetQueries());
  };

  return (
    selectedBooking && (
      <DrawerLayout
        visible={selectedBooking != null}
        title={selectedBooking.id}
        body={<BookingDrawerBody />}
        nestedDrawers={
          <>
            {(viewMode !== ViewMode.VEHICLE ||
              viewType === ViewType.TIME_TABLE) && (
              <NestedDrawer name="carEdit" />
            )}
            {viewMode !== ViewMode.AREA && <AreaEditDrawer />}
            {viewMode !== ViewMode.CATEGORIES && (
              <NestedDrawer name="categoryEdit" />
            )}
            {viewMode !== ViewMode.PRICING && <PricingEditDrawer />}
            {viewMode !== ViewMode.SHARE && <NestedDrawer name="trip" />}
            {viewMode !== ViewMode.USERS && <NestedDrawer name="users" />}
          </>
        }
        onReload={undefined}
        onClose={handleOnClose}
      />
    )
  );
};

export default BookingDrawer;
